import React, { memo } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styled';

const FixedFooter = ({ children, text, canShow }) => (
  <Styled.Wrapper canshow={Number(canShow)} position="fixed" color="primary">
    <Styled.Toolbar>
      {text &&
        <Styled.Text variant="h6" align="center">
          {text}
        </Styled.Text>
      }
      {children}
    </Styled.Toolbar>
  </Styled.Wrapper>
);

FixedFooter.propTypes = {
  children: PropTypes.node,
  canShow: PropTypes.bool,
  text: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.string,
  ]),
};

FixedFooter.defaultProps = {
  children: null,
  text: '',
  canShow: false,
};

export default memo(FixedFooter);